<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <ng-template #title>
      <h1>
        {{ 'label.eyeCatchers' | translate }}
      </h1>
    </ng-template>
    <div class="flex justify-end gap-2 mb-5">
      <p-button
        (click)="showEyeCatcherPopup()"
        [label]="'eyeCatcher.add' | translate"
      />
    </div>

    <p-table
      #eyecatcher
      [value]="eyeCatcherService.eyeCatchers()"
      stripedRows
      showGridlines
      dataKey="id"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="created_at"
      [sortOrder]="-1"
      [scrollable]="true"
      [loading]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      editMode="row"
    >
      <ng-template #header>
        <tr>
          <th rowspan="2" pSortableColumn="image" pResizableColumn>
            {{ 'eyeCatcher.image' | translate }}
          </th>
          <th rowspan="2" pSortableColumn="url" pResizableColumn>
            {{ 'eyeCatcher.url' | translate }}
            <p-sortIcon field="url" />
            <p-columnFilter
              field="url"
              matchMode="in"
              display="menu"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            >
              <ng-template #filter let-value let-filter="filterCallback">
                <p-multiselect
                  optionValue="key"
                  optionLabel="value"
                  [ngModel]="value"
                  [options]="urlOptions"
                  (onChange)="filter($event.value)"
                  [placeholder]="'eyeCatcher.url' | translate"
                  class="w-full"
                >
                </p-multiselect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="valid_from" pResizableColumn>
            {{ 'eyeCatcher.validFrom' | translate }}
            <p-sortIcon field="valid_from" />
            <p-columnFilter
              field="valid_from"
              display="menu"
              type="date"
              matchMode="dateAfter"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th rowspan="2" pSortableColumn="valid_until" pResizableColumn>
            {{ 'eyeCatcher.validUntil' | translate }}
            <p-sortIcon field="valid_until" />
            <p-columnFilter
              field="valid_until"
              display="menu"
              type="date"
              matchMode="dateBefore"
              [showOperator]="false"
              [showMatchModes]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-eyeCatcher>
        <tr [pEditableRow]="eyeCatcher">
          <td>
            <img
              [src]="eyeCatcher.image"
              alt="Bild"
              width="100"
              height="120"
              style="object-fit: cover; border-radius: 8px"
            />
          </td>
          <td>{{ getLinkName(eyeCatcher.url) }}</td>
          <td>{{ eyeCatcher.valid_from | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin' }}</td>
          <td>{{ eyeCatcher.valid_until | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin' }}</td>
          <td>
            <div class="flex items-center justify-center gap-2">
              <button
                *ngIf="!eyeCatcherPopupVisible"
                pButton
                type="button"
                pInitEditableRow
                icon="fa fa-pencil"
                (click)="onRowEditInit(eyeCatcher)"
                text
                rounded
                severity="secondary"
              ></button>
              <button
                pButton
                type="button"
                pInitEditableRow
                icon="fa fa-trash"
                (click)="onRowDeleteInit($event, eyeCatcher)"
                text
                rounded
                severity="secondary"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-confirmdialog />

    <p-dialog
      [header]="
        currentEyeCatcher?.id
          ? ('eyeCatcher.edit' | translate)
          : ('eyeCatcher.create' | translate)
      "
      [modal]="true"
      [(visible)]="eyeCatcherPopupVisible"
      styleClass="w-[90vw] max-w-4xl"
    >
      <form [formGroup]="eyeCatcherForm" (ngSubmit)="onSubmit()">
        <div class="flex flex-col md:flex-row gap-4 mb-4">
          <div class="flex flex-col gap-4 mb-4">
            <label for="image">{{ 'eyeCatcher.image' | translate }}</label>
            <p-fileupload
              #image
              name="demo[]"
              url="https://www.primefaces.org/cdn/api/upload.php"
              (onUpload)="onUpload($event)"
              [multiple]="true"
              accept="image/*"
              maxFileSize="50000000"
              mode="advanced"
              class="w-full grow"
              styleClass="h-full"
              [chooseLabel]="'label.fileChoose' | translate"
              [uploadLabel]="'label.fileUpload' | translate"
              [cancelLabel]="'label.cancel' | translate"
            >
              <ng-template #empty>
                <div>{{ 'label.fileDragDrop' | translate }}</div>
              </ng-template>
            </p-fileupload>
          </div>
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-4 mb-4 w-full">
              <label for="url">{{ 'eyeCatcher.url' | translate }}</label>
              <p-select
                inputId="url"
                [options]="urlOptions"
                optionLabel="value"
                optionValue="key"
                [placeholder]="'eyeCatcher.url' | translate"
                formControlName="url"
                class="w-full"
              />
            </div>

            <div class="flex flex-col gap-4 mb-4 w-full">
              <label for="valid_dates">{{
                'eyeCatcher.validDates' | translate
              }}</label>
              <p-datepicker
                inputId="valid_dates"
                selectionMode="range"
                [readonlyInput]="true"
                [showIcon]="true"
                [placeholder]="'eyeCatcher.validDates' | translate"
                (onSelect)="selectDateRange()"
                formControlName="valid_dates"
                styleClass="w-full"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-end gap-2">
          <p-button
            [label]="'label.cancel' | translate"
            severity="secondary"
            (click)="closeEyeCatcherPopup()"
          />
          <p-button [label]="'label.save' | translate" type="submit" />
        </div>
      </form>
    </p-dialog>
  </p-card>
</div>
